<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title id="title-card">
        <span v-if="editedItem.id" class="title">
          {{ $t("administration.modify-vehicle") }} "{{
            editedItem.name
          }}"</span
        >
        <span class="title" v-else>{{ $t("administration.new-vehicle") }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.name"
                :error-messages="
                  errorName ? $t('administration.add-vehicle.fieldError') : null
                "
                :label="$t('administration.header-table.name')"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.vin"
                :error-messages="
                  errorVin ? $t('administration.add-vehicle.fieldError') : null
                "
                :disabled="!!editedItem.id"
                :label="$t('administration.header-table.vin')"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-select
                :value="editedItem.make"
                :error-messages="
                  errorMake ? $t('administration.add-vehicle.fieldError') : null
                "
                :items="getMakesOption"
                :disabled="!!editedItem.id"
                @input="setVehicleMake"
                item-text="name"
                item-value="id"
                class="tableSize vehicleMake"
                :label="$t('administration.header-table.mark')"
              >
              </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-select
                :value="editedItem.model.model"
                :items="getModelOptions"
                :error-messages="
                  errorModel
                    ? $t('administration.add-vehicle.fieldError')
                    : null
                "
                :disabled="!!editedItem.id"
                return-object
                item-text="model"
                class="tableSize"
                :label="$t('administration.header-table.model')"
                @input="setVehicleModel"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.badge"
                :label="$t('administration.header-table.badge')"
                :error-messages="
                  errorBadge
                    ? $t('administration.add-vehicle.fieldError')
                    : null
                "
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-checkbox
                v-model="editedItem.priority"
                color="#10367A"
                :ripple="false"
                :label="$t('administration.header-table.priority')"
              >
              </v-checkbox>
            </v-col>
          </v-layout>
          <span
            class="inputError"
            v-if="
              editedItem.make === 'Autre' || editedItem.model.model === 'Autre'
            "
            >{{ $t("administration.contact-dreev") }}</span
          >
          <span class="inputError" v-else>{{ errorRequest }}</span>
        </v-container>
      </v-card-text>
      <v-card-actions id="card-cation">
        <baseButton
          id="cancelBtn"
          :value="$t('administration.add-vehicle.cancel')"
          :action="close"
          white
        />
        <baseButton
          id="saveBtn"
          class="saveBtn"
          :value="$t('administration.add-vehicle.save')"
          :action="saveItem"
          :active="areVehicleInfosValid"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import baseButton from '@/components/base-button.vue'
export default {
  data () {
    return {
      editedItem: {
        name: null,
        vin: null,
        make: null,
        model: { model: null },
        badge: null,
        priority: 0
      },
      dialog: false,
      rules: {
        infos: [val => (val || '').length > 0 || this.$i18n.t('administration.fieldRequired')]
      },
      errorName: false,
      errorVin: false,
      errorMake: false,
      errorModel: false,
      errorBadge: false,
      copyItem: null,
      errorRequest: null
    }
  },
  components: {
    baseButton
  },
  mounted () {
    this.getVehicleMake()
  },
  computed: {
    ...mapGetters('vehicle', ['getModels', 'getMakes', 'getFleetId']),
    getMakesOption () {
      const listmakesOption = []
      this.getMakes.forEach(element => {
        listmakesOption.push(element.name)
      })
      listmakesOption.push('Autre')
      return listmakesOption
    },
    areVehicleInfosValid () {
      if (this.editedItem.id) {
        if (this.editedItem.name === this.copyItem.name &&
            this.editedItem.badge === this.copyItem.badge &&
            this.editedItem.priority === this.copyItem.priority) {
          return false
        }
      }

      if (
        this.editedItem.name &&
        this.editedItem.vin &&
        this.editedItem.vin !== '' &&
        this.editedItem.model &&
        this.editedItem.model.model !== '' &&
        this.editedItem.make &&
        this.editedItem.make !== '' &&
        this.editedItem.badge &&
        this.editedItem.badge !== '' &&
        this.editedItem.make !== 'Autre' &&
        this.editedItem.model.model !== 'Autre'
      ) { return true }

      return false
    },
    getModelOptions () {
      return [...this.getModels, { model: 'Autre' }]
    }
  },
  methods: {
    ...mapActions('vehicle', ['modifyVehicle', 'getVehicleModel', 'getVehicleMake', 'addNewVehicle']),
    display (item) {
      this.errorRequest = null
      this.errorName = false
      this.errorVin = false
      this.errorMake = false
      this.errorModel = false
      this.errorBadge = false
      this.copyItem = null
      this.dialog = false
      this.editedItem = item || {
        name: null,
        vin: null,
        make: null,
        model: { model: null },
        badge: null,
        priority: 0
      }

      if (item) {
        this.copyItem = { ...item }
      }

      if (this.editedItem.make) {
        this.getVehicleModel(this.editedItem.make)
      }

      this.dialog = true
    },
    setVehicleMake (make) {
      this.editedItem.make = make
      this.getVehicleModel(this.editedItem.make)
    },
    setVehicleModel (model) {
      this.editedItem.model = model
    },
    close () {
      this.dialog = false
      this.vehicleInfosAreValid = true

      this.editedItem = {
        name: null,
        vin: null,
        make: null,
        model: { model: null },
        badge: null,
        priority: 0
      }
    },

    async saveItem () {
      this.testError = true
      if (this.areVehicleInfosValid) {
        if (this.editedItem.id) {
          const body = {}
          if (this.editedItem.name !== this.copyItem.name) {
            body.name = this.editedItem.name
          }
          if (this.editedItem.badge !== this.copyItem.badge) {
            body.badge = this.editedItem.badge
          }
          if (this.editedItem.priority !== this.copyItem.priority) {
            body.priority = this.editedItem.priority ? 1 : 0
          }
          const error = await this.modifyVehicle({ fleetID: this.getFleetId, vehicleId: this.editedItem.id, body })
          if (error) {
            switch (error) {
              case 'GENERIC':
                this.errorRequest = this.$i18n.t('administration.add-vehicle.genericError')
                break
              case 'VIN':
                this.errorRequest = this.$i18n.t('administration.add-vehicle.vinError')
                break
              case 'BADGE':
                this.errorRequest = this.$i18n.t('administration.add-vehicle.BadgeError')
                break
            }
            return
          }
        } else {
          const body = {
            name: this.editedItem.name,
            vin: this.editedItem.vin,
            modelId: this.editedItem.model.id,
            badge: this.editedItem.badge,
            priority: this.editedItem.priority ? 1 : 0
          }
          const error = await this.addNewVehicle({ fleetID: this.getFleetId, body })
          if (error) {
            switch (error) {
              case 'GENERIC':
                this.errorRequest = this.$i18n.t('administration.add-vehicle.genericError')
                break
              case 'VIN':
                this.errorRequest = this.$i18n.t('administration.add-vehicle.vinError')
                break
              case 'BADGE':
                this.errorRequest = this.$i18n.t('administration.add-vehicle.BadgeError')
                break
            }
            return
          }
        }
        this.close()
      }
    }
  }
}
</script>

<style>
.v-dialog {
  width: auto !important;
  border: 1px solid rgba(0, 0, 0, 0.7);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
}
.tableSize {
  width: 150px;
}
.inputError {
  color: rgba(249, 19, 19, 1);
  font-size: 15px;
  font-weight: 700;
  line-height: 21px;
  text-align: center;
}

.title {
  margin-top: 17px;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  color: #10367a;
}

#title-card {
  display: flex;
  justify-content: center;
}

#card-cation {
  display: flex;
  justify-content: center;
}

.saveBtn {
  margin-left: 48px;
  margin-bottom: 30px;
}

#cancelBtn {
  margin-bottom: 30px;
}
</style>
